"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class HashTable {
    constructor(array = [], prop = 'id') {
        this._prop = prop;
        this._array = array;
        this.table = this._arrayToDict(this._array);
    }
    add(item) {
        this._array.push(item);
        this.table[item[this._prop]] = item;
        return this;
    }
    delete(item) {
        if (typeof item === 'string' || typeof item === 'number') {
            item = this.get(item);
        }
        if (item) {
            this._array.forEach((arrayItem, i) => {
                if (arrayItem[this._prop] === item[this._prop]) {
                    this._array.splice(i, 1);
                }
            });
            return delete this.table[item[this._prop]];
        }
        return false;
    }
    get(index = 0) {
        return index ? this.table[index] : this._array[index];
    }
    get length() {
        return this._array.length;
    }
    get array() {
        return this._array;
    }
    _arrayToDict(array) {
        return array.reduce((obj, item) => {
            obj[item[this._prop]] = item;
            return obj;
        }, {});
    }
}
exports.default = HashTable;
